<script src="https://apis.google.com/js/platform.js"></script>

<mat-toolbar>
  <div>Environment Management</div>
  <span class="spacer"></span>
  <div style="float:right; position: fixed; bottom: 50px; right: 2%; z-index: 100; display: flex; flex-direction: column-reverse; align-items: center;">
    <button mat-fab color="primary" aria-label="Add User" (click)="addEnvironment()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</mat-toolbar>

<div>

  <ngx-datatable
    #filtersTable
    class="material"
    [loadingIndicator]=loading
    [columnMode]="ColumnMode.flex"
    [headerHeight]="50"
    [footerHeight]="50"
    [rowHeight]="50"
    [rows]="environments$ | async"
    [limit]="10">

    <ngx-datatable-column name="Name" [sortable]="false" [flexGrow]="2">
      <ng-template let-environment="row" ngx-datatable-cell-template>
        <strong>{{ environment.name }}</strong>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Url" [sortable]="false" [flexGrow]="3">
      <ng-template let-environment="row" ngx-datatable-cell-template>
        <strong>{{ environment.url }}</strong>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Reference" [sortable]="false" [flexGrow]="3">
      <ng-template let-environment="row" ngx-datatable-cell-template>
        <strong>{{ environment.reference }}</strong>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Actions" [sortable]="false" [flexGrow]="1">
      <ng-template let-environment="row" ngx-datatable-cell-template>
        <a (click)="$event.stopPropagation(); environmentClicked(environment)" style="color: blue; cursor: pointer;">
          <mat-icon matTooltip="View" style="color:royalblue">visibility</mat-icon>
        </a>
        <mat-icon style="color:gray">more_vert</mat-icon>
        <a (click)="$event.stopPropagation(); deleteEnvironment('Delete', environment)" style="color: blue; cursor: pointer;">
          <mat-icon matTooltip="Delete" style="color:red">delete</mat-icon>
        </a>
      </ng-template>
    </ngx-datatable-column>

  </ngx-datatable>

</div>



